import { createSelector } from "reselect";
import CountriesModel from "../../models/countries/CountriesModel";

export const selectAllCountries: (any) => CountriesModel[] = state => {
    return Object.values(state.countries || {});
};
export const selectVisibleCountries = createSelector([selectAllCountries], allCountries =>
    allCountries?.filter((c: any) => c.isCustomerVisible)
);
